module["exports"] = [
  "#####",
  "#####-####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/address/postcode.js
// module id = 1388
// module chunks = 0